import {CommonModule} from '@angular/common';
import {Component, ElementRef, QueryList, ViewChildren, ChangeDetectorRef} from '@angular/core';
import {SidebarService} from '../../services/sidebar.service';
import {NavigationEnd, Router, RouterModule} from '@angular/router';
import {SafeHtmlPipe} from '../../pipe/safe-html.pipe';
import {SidebarWidgetComponent} from './app-sidebar-widget.component';
import {combineLatest, Subscription, Observable} from 'rxjs';
import { AdminService } from '../../services/admin.service';

type NavItem = {
    name: string;
    icon: string;
    path?: string;
    new?: boolean;
    subItems?: { name: string; path: string; pro?: boolean; new?: boolean }[];
};

@Component({
    selector: 'app-sidebar',
    imports: [
        CommonModule,
        RouterModule,
        SafeHtmlPipe,

    ],
    templateUrl: './app-sidebar.component.html',
})
export class AppSidebarComponent {

    // Main nav items
    navItems: NavItem[] = [
        {
            icon: `<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" aria-hidden="true" role="img"><path d="M21 15a2 2 0 0 1-2 2H8l-4 4V5a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round"/></svg>`,
            name: "Chat",
            path: "/chat",
        },
        {
            icon: `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4'/><path d='M17 8l-5-5-5 5'/><path d='M12 3v12'/></svg>`,
            name: "Files",
            path: "/files",
        },
        {
            icon: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 14.1526 4.3002 16.1184 5.61936 17.616C6.17279 15.3096 8.24852 13.5955 10.7246 13.5955H13.2746C15.7509 13.5955 17.8268 15.31 18.38 17.6167C19.6996 16.119 20.5 14.153 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM17.0246 18.8566V18.8455C17.0246 16.7744 15.3457 15.0955 13.2746 15.0955H10.7246C8.65354 15.0955 6.97461 16.7744 6.97461 18.8455V18.856C8.38223 19.8895 10.1198 20.5 12 20.5C13.8798 20.5 15.6171 19.8898 17.0246 18.8566ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM11.9991 7.25C10.8847 7.25 9.98126 8.15342 9.98126 9.26784C9.98126 10.3823 10.8847 11.2857 11.9991 11.2857C13.1135 11.2857 14.0169 10.3823 14.0169 9.26784C14.0169 8.15342 13.1135 7.25 11.9991 7.25ZM8.48126 9.26784C8.48126 7.32499 10.0563 5.75 11.9991 5.75C13.9419 5.75 15.5169 7.32499 15.5169 9.26784C15.5169 11.2107 13.9419 12.7857 11.9991 12.7857C10.0563 12.7857 8.48126 11.2107 8.48126 9.26784Z" fill="currentColor"></path></svg>`,
            name: "User Profile",
            path: "/profile",
        },
        {
            icon: `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2'/><circle cx='12' cy='7' r='4'/></svg>`,
            name: "Users",
            path: "/users",
        },
        {
            icon: `<svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M3 12h18'/><path d='M12 3v18'/></svg>`,
            name: "System Prompt",
            path: "/system-prompt",
        },
        {
            icon: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="M9 3.75H6.912a2.25 2.25 0 0 0-2.15 1.588L2.35 13.177a2.25 2.25 0 0 0-.1.661V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 0 0-2.15-1.588H15M2.25 13.5h3.86a2.25 2.25 0 0 1 2.012 1.244l.256.512a2.25 2.25 0 0 0 2.013 1.244h3.218a2.25 2.25 0 0 0 2.013-1.244l.256-.512a2.25 2.25 0 0 1 2.013-1.244h3.859M12 3v8.25m0 0-3-3m3 3 3-3" /></svg>`,
            name: "Import",
            path: "/import",
        },
    ];
    // Others nav items
    othersItems: NavItem[] = [
        {
            icon: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14 2.75C14 2.33579 14.3358 2 14.75 2C15.1642 2 15.5 2.33579 15.5 2.75V5.73291L17.75 5.73291H19C19.4142 5.73291 19.75 6.0687 19.75 6.48291C19.75 6.89712 19.4142 7.23291 19 7.23291H18.5L18.5 12.2329C18.5 15.5691 15.9866 18.3183 12.75 18.6901V21.25C12.75 21.6642 12.4142 22 12 22C11.5858 22 11.25 21.6642 11.25 21.25V18.6901C8.01342 18.3183 5.5 15.5691 5.5 12.2329L5.5 7.23291H5C4.58579 7.23291 4.25 6.89712 4.25 6.48291C4.25 6.0687 4.58579 5.73291 5 5.73291L6.25 5.73291L8.5 5.73291L8.5 2.75C8.5 2.33579 8.83579 2 9.25 2C9.66421 2 10 2.33579 10 2.75L10 5.73291L14 5.73291V2.75ZM7 7.23291L7 12.2329C7 14.9943 9.23858 17.2329 12 17.2329C14.7614 17.2329 17 14.9943 17 12.2329L17 7.23291L7 7.23291Z" fill="currentColor"></path></svg>`,
            name: "Authentication",
            subItems: [
                {name: "Sign In", path: "/signin", pro: false},
                {name: "Sign Up", path: "/signup", pro: false},
            ],
        },
    ];

    openSubmenu: string | null | number = null;
    subMenuHeights: { [key: string]: number } = {};
    @ViewChildren('subMenu') subMenuRefs!: QueryList<ElementRef>;

    readonly isExpanded$: Observable<boolean>;
    readonly isMobileOpen$: Observable<boolean>;
    readonly isHovered$: Observable<boolean>;

    private subscription: Subscription = new Subscription();

    constructor(
        public sidebarService: SidebarService,
        private router: Router,
        private cdr: ChangeDetectorRef,
        private adminService: AdminService
    ) {
        this.isExpanded$ = this.sidebarService.isExpanded$;
        this.isMobileOpen$ = this.sidebarService.isMobileOpen$;
        this.isHovered$ = this.sidebarService.isHovered$;
    }

    ngOnInit() {
        // Subscribe to router events
        this.subscription.add(
            this.router.events.subscribe(event => {
                if (event instanceof NavigationEnd) {
                    this.setActiveMenuFromRoute(this.router.url);
                }
            })
        );

        // Subscribe to combined observables to close submenus when all are false
        this.subscription.add(
            combineLatest<[boolean, boolean, boolean]>([this.isExpanded$, this.isMobileOpen$, this.isHovered$]).subscribe(
                ([isExpanded, isMobileOpen, isHovered]) => {
                    if (!isExpanded && !isMobileOpen && !isHovered) {
                        // this.openSubmenu = null;
                        // this.savedSubMenuHeights = { ...this.subMenuHeights };
                        // this.subMenuHeights = {};
                        this.cdr.detectChanges();
                    } else {
                        // Restore saved heights when reopening
                        // this.subMenuHeights = { ...this.savedSubMenuHeights };
                        // this.cdr.detectChanges();
                    }
                }
            )
        );

        // Initial load
        this.setActiveMenuFromRoute(this.router.url);
    }

    ngOnDestroy() {
        // Clean up subscriptions
        this.subscription.unsubscribe();
    }

    isActive(path: string): boolean {
        return this.router.url === path;
    }

    toggleSubmenu(section: string, index: number) {
        const key = `${section}-${index}`;

        if (this.openSubmenu === key) {
            this.openSubmenu = null;
            this.subMenuHeights[key] = 0;
        } else {
            this.openSubmenu = key;

            setTimeout(() => {
                const el = document.getElementById(key);
                if (el) {
                    this.subMenuHeights[key] = el.scrollHeight;
                    this.cdr.detectChanges(); // Ensure UI updates
                }
            });
        }
    }

    onSidebarMouseEnter() {
        this.isExpanded$.subscribe(expanded => {
            if (!expanded) {
                this.sidebarService.setHovered(true);
            }
        }).unsubscribe();
    }

    private setActiveMenuFromRoute(currentUrl: string) {
        const menuGroups = [
            {items: this.navItems, prefix: 'main'},
            {items: this.othersItems, prefix: 'others'},
        ];

        menuGroups.forEach(group => {
            group.items.forEach((nav, i) => {
                if (nav.subItems) {
                    nav.subItems.forEach(subItem => {
                        if (currentUrl === subItem.path) {
                            const key = `${group.prefix}-${i}`;
                            this.openSubmenu = key;

                            setTimeout(() => {
                                const el = document.getElementById(key);
                                if (el) {
                                    this.subMenuHeights[key] = el.scrollHeight;
                                    this.cdr.detectChanges(); // Ensure UI updates
                                }
                            });
                        }
                    });
                }
            });
        });
    }

    onSubmenuClick() {
        console.log('click submenu');
        this.isMobileOpen$.subscribe(isMobile => {
            if (isMobile) {
                this.sidebarService.setMobileOpen(false);
            }
        }).unsubscribe();
    }

    clearAllData() {
        const confirmed = window.confirm('This will permanently delete all files and vector documents. Do you want to proceed?');
        if (!confirmed) return;
        this.adminService.clearFilesAndDocuments().subscribe({
            next: () => {
                window.alert('All files and documents have been deleted.');
            },
            error: (err) => {
                console.error('Failed to clear data', err);
                window.alert('Failed to delete data. Please check backend logs.');
            }
        });
    }
}
